import { render } from "./oauth_callback.vue?vue&type=template&id=4ad76d3f&scoped=true"
import script from "./oauth_callback.vue?vue&type=script&lang=js"
export * from "./oauth_callback.vue?vue&type=script&lang=js"

import "./oauth_callback.vue?vue&type=style&index=0&id=4ad76d3f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad76d3f"]])

export default __exports__